import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IPaymentConfigEntity } from '../../entity';
import { IGetPaymentUseCase } from '../../core/usecases/paymentConfig/GetPaymentConfigUseCase';
export interface IPaymentConfigService {
    getPaymentConfig(): Promise<IPaymentConfigEntity['data']>;
}

export class PaymentConfigService implements IPaymentConfigService {
    // Lazy getter for dependency to avoid circular dependencies
    private get getPaymentConfigUseCase(): IGetPaymentUseCase {
        return container.resolve<IGetPaymentUseCase>(DI.USECASES.IGetPaymentUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getPaymentConfig(): Promise<IPaymentConfigEntity['data']> {
        const response = await this.getPaymentConfigUseCase.execute();
        return response;
    }
}
